import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { OpenIdConnectLogoutService } from '@pages/logout/services/open-id-connect-logout.service';
import {
  OpenIdConnectLogOut,
  OpenIdConnectLogOutCompleted,
  OpenIdConnectLogOutError,
} from '@pages/logout/store/actions/open-id-connect-logout.actions';
import { HttpErrorResponse } from '@angular/common/http';

@State<void>({
  name: 'openIdConnectLogout',
})
@Injectable()
export class OpenIdConnectLogoutState {
  private readonly openIdConnectLogoutService = inject(OpenIdConnectLogoutService);

  @Action(OpenIdConnectLogOut)
  loadLoginConfiguration(context: StateContext<void>, { logoutRequest }: OpenIdConnectLogOut): Observable<boolean> {
    return this.openIdConnectLogoutService.logOut(logoutRequest).pipe(
      tap(isLoggedOut =>
        isLoggedOut ? context.dispatch(new OpenIdConnectLogOutCompleted()) : context.dispatch(new OpenIdConnectLogOutError())
      ),
      catchError((httpErrorResponse: HttpErrorResponse) => {
        context.dispatch(new OpenIdConnectLogOutError());

        return throwError(() => httpErrorResponse);
      })
    );
  }
}
